import React, { useEffect, useState } from 'react';
import { Grid, Checkbox, Typography, LinearProgress, TextField } from '@material-ui/core';
import { createReportStyles } from './styles';
import { useSelector } from 'react-redux';

export default function SelectUsers({ onSelect }) {
  const classes = createReportStyles();

  const { users, loading } = useSelector((state) => state.users);

  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState(users);

  const handleSelect = (id: string) => {
    setSelectedUsers((prev) =>
      prev.includes(id) ? prev.filter((userId) => userId !== id) : [...prev, id]
    );
  };

  useEffect(() => {
    const permission_ids = [];

    selectedUsers.forEach((userId) => {
      const user = users.find((user) => user.id === userId);
      if (user) {
        // @ts-ignore
        permission_ids.push(user.permissions.permissions_id);
      }
    });

    onSelect(permission_ids);
  }, [selectedUsers]);

  useEffect(() => {
    setFilteredUsers(
      users.filter((user) =>
        `${user.firstname} ${user.lastname}`.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, users]);

  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <Typography className={classes.createUsersHeading}>Select Users</Typography>
        {loading && <LinearProgress />}
      </Grid>
      <Grid item>
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          placeholder="Filter users..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </Grid>
      <Grid container className={classes.currentUsersContainer}>
        {filteredUsers.map((user) => {
          const name = `${user.firstname} ${user.lastname}`;
          return (
            <Grid item xs={12} sm={4} key={user.id} className={classes.userRow}>
              <Grid container alignItems="center" direction="row" spacing={2}>
                <Grid item>
                  <Checkbox
                    checked={selectedUsers.includes(user.id)}
                    onChange={() => handleSelect(user.id)}
                  />
                </Grid>
                <Grid item xs onClick={() => handleSelect(user.id)}>
                  <Typography>{name}</Typography>
                </Grid>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
}
